export var THEME_EMPTY = 'THEME_EMPTY';
export var emptyObj = Object.freeze({});
export var emptyArray = Object.freeze([]);
export var emptyFunction = function emptyFunction() {};
/**
 * UED 内部使用主题名
 */

export var EUedThemeName;
/**
 * 空模板需设置为此方法，用于判断是否生成style标签
 * @returns
 */

(function (EUedThemeName) {
  EUedThemeName["theme1"] = "theme1";
  EUedThemeName["theme2"] = "theme2";
  EUedThemeName["theme3"] = "theme3";
  EUedThemeName["theme4"] = "theme4";
  EUedThemeName["theme5"] = "theme5";
  EUedThemeName["theme6"] = "theme6";
  EUedThemeName["customTheme"] = "customTheme";
})(EUedThemeName || (EUedThemeName = {}));
export var emptyCSSTemplateFunc = function emptyCSSTemplateFunc() {
  return '';
};